<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
// window.onload = function(){
// 	var h1 = document.getElementById("headNav").clientHeight
// 	var h2 = document.getElementById("menu").clientHeight
// 	var h3 = document.getElementById("search").clientHeight
// 	var h4 = document.getElementById("footer").clientHeight
// 	var minheight = `calc(100vh - ${h1+h2+h3+h4}px )`

// 	document.getElementsByClassName('min-height')[0].style.minHeight = minheight
// 	console.log(document.getElementsByClassName('min-height'),'头部导航')
// }
import Cookies from 'js-cookie';
import utils from '@/utils/utils.js'
export default {
	name: 'App',
	mounted() {
		//20251216修改
		if(this.$route.query.source == 'wqqyfw' || localStorage.getItem('source') == 'wqqyfw'){
			localStorage.setItem('source', 'wqqyfw')
			this.getGmjjflList()
			this.getIndustryTypeList()
			this.getScaleList()
			this.getScaleRangeList()
			this.getEnterpriseSituationList()
			this.getEnterpriseTypeList()
			this.getDigitalLevelList()
			this.getBuyTypeList()
			this.getDeployTypeList()
			this.getSceneTypeList()
			this.getRegionList()
			if(!Cookies.get('token')){
				Cookies.set('showNotice', 0);
			}
			// if(Cookies.get('showNotice')!=2){
			// 	// 值等于2的时候代表已经弹窗过了，不需要再弹窗，等于1的时候代表第一次进入，需要弹窗
			// 	Cookies.set('showNotice', 1);
			// }
		}else{
			window.location.href = this.$url.gxjUrl
			// alert('您当前不是通过企业数字化平台访问的，不能进行操作')
		}
		
	},
	methods: {
		// 国民经济分类
		getGmjjflList() {
			this.$api.get('/digital/dicClassify/getTree', { params: { type: 'EC', noPid: 0 } }).then(res => {
				utils.gmjjflList = res.data
			})
		},
		// 场景类型
		getSceneTypeList(){
			this.$api.get('/digital/dicClassify/getTree',{ params: { type: 'ST', noPid: 0 } }).then((res) => {
				if (res.code == 0) {
					utils.sceneTypeList = res.data
				}
			})
		},	
		// 行业类型
		getIndustryTypeList() {
			utils.industryTypeListFWS = []
			utils.industryTypeList = []
			this.$api.get('/sys/dict/data/list?dictTypeId=2').then((res) => {
				if (res.code == 0) {
					res.data.forEach(ele => {
						utils.industryTypeListFWS.push(ele)
						if(ele.dictLabel != '其他'){
							utils.industryTypeList.push(ele)
						}
					});
				}
			})
		},
		// 企业规模
		getScaleList() {
			this.$api.get('/sys/dict/data/list?dictTypeId=6').then((res) => {
				if (res.code == 0) {
					utils.scaleList = res.data
				}
			})
		},
		// 规模范围	
		getScaleRangeList() {
			this.$api.get('/sys/dict/data/list?dictTypeId=8').then((res) => {
				if (res.code == 0) {
					utils.companyRange = res.data
				}
			})
		},
		// 优质中小企业情况
		getEnterpriseSituationList() {
			this.$api.get('/sys/dict/data/list?dictTypeId=7').then((res) => {
				if (res.code == 0) {
					utils.enterpriseSituationList = res.data
				}
			})
		},
		// 企业类型
		getEnterpriseTypeList() {
			this.$api.get('/sys/dict/data/list?dictTypeId=5').then((res) => {
				if (res.code == 0) {
					utils.enterpriseType = res.data
				}
			})
		},
		// 数字化等级
		getDigitalLevelList() {
			this.$api.get('/sys/dict/data/list?dictTypeId=9').then((res) => {
				if (res.code == 0) {
					utils.digitalLevelList = res.data
				}
			})
		},
		// 购买方式
		getBuyTypeList() {
			this.$api.get('/sys/dict/data/list?dictTypeId=3').then((res) => {
				if (res.code == 0) {
					utils.buyTypeList = res.data
				}
			})
		},
		// 部署方式
		getDeployTypeList() {
			this.$api.get('/sys/dict/data/list?dictTypeId=4').then((res) => {
				if (res.code == 0) {
					utils.deployTypeList = res.data
				}
			})
		},
		// 区域
		getRegionList(){
			utils.regionOptions = []
			utils.regionOptionsFWS = []
			this.$api.get('/sys/dict/data/list?dictTypeId=1').then((res)=>{
				if(res.code == 0){
					res.data.forEach(ele => {
						utils.regionOptionsFWS.push(ele)
						if(ele.dictLabel != '其他'){
							utils.regionOptions.push(ele)
						}
					});
				}
			})
		},
	}
}
</script>

<style>
@import url('../src/assets/css/public.css');
@import url('../src/assets/css/1400.css');
@import url('../src/assets/css/768.css');
@import url('../src/assets/css/767.css');
@import "./assets/font/font.css";

#app {
	font-family: 'albbphr';
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	/* font-family: 'albb'; */
}

body {
	padding: 0;
	margin: 0;
}

.el-picker-panel,
.el-message {
	font-size: 16px !important;
}

.edui-default {
	z-index: 9999 !important;
}

/* .el-dialog {
		height: 7rem;
	} */

.el-dialog .el-dialog__body {
	height: calc(100% - 1.84rem);
	overflow: hidden;
	overflow-y: auto;
}

.dhzx {
	display: flex;
	align-items: center;
}

.dhzx .el-dialog {
	height: 150px;
}

.dhzx .el-dialog__body {
	height: auto;
	overflow: inherit
}

.el-dialog__body::-webkit-scrollbar {
	width: 3px;
	height: 3px;
	background: transparent;
}

.el-dialog__body::-webkit-scrollbar-thumb {
	border-radius: 10px;
	box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	background: #e5e7eb;
}

.el-upload-list__item {
	transition: none !important;
	-webkit-transition: nonne !important;
}

.el-upload-list__item-name {
	transition: none !important;
	-webkit-transition: nonne !important;
}

.el-dialog__header {
	background: #f3f3fd;
}

@media only screen and (max-width: 767px) {
	.el-message-box {
		width: 72%;
	}
}

#edui_fixedlayer {
	z-index: 9999 !important;
}

.edui-default .edui-popup {
	z-index: 999999 !important;
}

.edui-editor div {
	line-height: normal;
}

.edui-default .edui-popup-content {
	z-index: 999999 !important;
	position: relative;
}

/* 浏览器滚动条样式 */
::-webkit-scrollbar {
	width: 4px;
	height: 10px;
	background: transparent;
}

::-webkit-scrollbar-thumb {
	background: rgb(174, 174, 174);
	border-radius: 50px;
}

::-webkit-scrollbar-track {
	background: transparent;
}

.el-table th {
	color: #303133 !important;
	background-color: #f5f7fa !important;
}
.ant-descriptions-view table {
	width: 100%;
	table-layout: fixed;
	border-collapse: collapse;
}

.ant-descriptions-view {
	width: 100%;
	overflow: hidden;
	border-radius: 4px;
}

.ant-descriptions-item {
	box-sizing: border-box;
	vertical-align: top;
	/* padding-bottom: 6px; */
	border: 1px solid #e3edf5;
	vertical-align: middle;
	padding: 10px 8px;
	/* text-align: center; */
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}

.ant-descriptions-item.table-title {
	background: #f2f9fc;
	font-weight: bold;
	text-align: center;
}

.ta-l {
	text-align: left;
}
</style>